import Vue from 'vue'
import * as moment from 'moment';
import i18n from './i18n'

const locale = i18n.locale;



/* eslint-disable */
Vue.filter('date', function (value) {
    if (!value) return ' - '  

    if (locale === 'pt')
        return moment(value).format("DD/MM/YYYY")
    else 
        return moment(value).format('YYYY-MM-DD');
});

Vue.filter('currency', function(value, hasPrefix) {
    const { decimal, thousands, prefix } = locale === 'pt' ? { decimal: ',', thousands: '.', prefix: 'R$ ' } : { decimal: '.', thousands: ',', prefix: '$ ' };

    if (value === null)
        return (hasPrefix ? prefix : '') + '0' + decimal + '00';

    let newValue = value.toFixed(2).split('.');
    let numberPart = newValue[0];
    let newStr = '';
    let decimalPart = newValue[1];

    for (let index = numberPart.length - 1, indexDecimal = 1; index >= 0; index--, indexDecimal++) {
        const element = numberPart[index];
        const by3 = indexDecimal % 3;
        newStr = element + newStr;
        if (by3 === 0 && index !== 0)
            newStr = thousands + newStr;                    
    }           
    
    return (hasPrefix ? prefix : '') + newStr + decimal + decimalPart;
});

Vue.filter('strZero', function (value, qtd) {
    if (!value) return ''  
    return  (String(value).padStart(qtd));
});

Vue.filter('formata', function (value, tipo) {    
    if (!value) return '';    
    if (!tipo) return value;

    if (tipo === "documento") {
        if (value.length === 11) {
            return `${value.substr(0, 3)}.${value.substr(3, 3)}.${value.substr(6, 3)}-${value.substr(9, 2)}`
        } else if (value.length === 14) {
            return `${value.substr(0, 2)}.${value.substr(2, 3)}.${value.substr(5, 3)}/${value.substr(8, 4)}-${value.substr(12, 2)}`
        }
    }

    if (tipo === "telefone") {        
        var novoValor = value.replace(/\D/g,"");             //Remove tudo o que não é dígito
        novoValor=novoValor.replace(/^(\d{2})(\d)/g,"($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
        novoValor=novoValor.replace(/(\d)(\d{4})$/,"$1-$2");    //Coloca hífen entre o quarto e o quinto dígitos
        return novoValor;
    }

    return value;
});